import React from 'react';
import styled from 'styled-components';
import { User } from '../services/authService';
import { auth } from '../firebase/config';
import defaultProfileImage from '../assets/default-profile.jpg';
import { useNavigate, useLocation } from 'react-router-dom';


interface TopBarProps {
  user: User | null;
}

const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  width: 100%;
  margin-bottom: 30px;
`;

const UserInfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileImageContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserName = styled.span`
  font-weight: 600;
  font-size: 16px;
`;

const UserEmail = styled.span`
  font-size: 14px;
  color: #666;
`;

const ProfileIcon = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  i {
    font-size: 24px;
    color: #000;
  }
`;
const TopBar: React.FC<TopBarProps> = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleMyProfile = async () => {
        try {
          await auth.signOut();
          navigate('/login');
        } catch (error) {
          console.error('Error signing out:', error);
        }
  };
  return (
    <TopBarContainer>
      <UserInfoContainer>
      <ProfileImageContainer>
        <img
        src={user?.profilePictureURL || defaultProfileImage}
        alt="Profile"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = defaultProfileImage;
        }}
        />
      </ProfileImageContainer>
      <UserDetails>
        <UserName>
          {user?.firstName && user?.lastName 
            ? `${user.firstName} ${user.lastName}`
            : user?.firstName 
              ? user.firstName
              : user?.lastName
                ? user.lastName
                : 'Loading...'
          }
        </UserName>
        <UserEmail>{user?.email || 'Loading...'}</UserEmail>
      </UserDetails>
      </UserInfoContainer>
      {location.pathname === '/dashboard' ? (
      <ProfileIcon onClick={handleMyProfile}>
        <i className='bx bx-log-out'></i> {/* Logout icon on dashboard */}
      </ProfileIcon>
      ) : (
      <ProfileIcon onClick={() => navigate('/dashboard')}> {/* Navigate to profile on other pages */}
        <i className='bx bx-user-circle'></i> {/* User icon */}
      </ProfileIcon>
      )}
    </TopBarContainer>
  );
};

export default TopBar;